import { render, staticRenderFns } from "./ad-image.vue?vue&type=template&id=effca840&lang=html"
import script from "./ad-image.vue?vue&type=script&lang=js"
export * from "./ad-image.vue?vue&type=script&lang=js"
import style0 from "./ad-image.vue?vue&type=style&index=0&id=effca840&prod&lang=less"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports